/* eslint @typescript-eslint/no-explicit-any: 0 */

import { connectStateResults } from 'react-instantsearch-dom';

import IfHits from './IfHits';
import { Index } from './InstantSearch';
import { searchTypes } from './SearchPanelResultsTypes';

type RefinedResultsProps = {
  currentDisplay: string;
  displayType: React.Dispatch<React.SetStateAction<string>>;
  label: string;
  searchResults: any;
  type: string;
};

type RefinedResultsItemProps = {
  displayState: string;
  indexId: string;
  label: string;
  searchCondition: (searchResults: any) => boolean;
  setDisplayState: React.Dispatch<React.SetStateAction<string>>;
  type: string;
};

type SearchPanelRefinedResultsProps = {
  displayState: string;
  redirectLinks: any;
  searchCondition: (searchResults: any) => boolean;
  searchOptions: any;
  setDisplayState: React.Dispatch<React.SetStateAction<string>>;
};

const RefinedResults = connectStateResults(
  ({
    searchResults,
    type,
    label,
    currentDisplay,
    displayType
  }: RefinedResultsProps) =>
    searchResults && (
      <li className="mr-5">
        <button
          type="button"
          className={`text-title-sm cursor-pointer ${
            type === currentDisplay ? 'font-bold' : 'font-light'
          }`}
          onClick={() => {
            displayType(type);
          }}
        >
          {label}
        </button>
      </li>
    )
);

export function RefinedResultsItem({
  indexId,
  label,
  type,
  setDisplayState,
  displayState,
  searchCondition
}: RefinedResultsItemProps) {
  const indexObject = {
    Root: ({ children }: { children: any }) => children,
    props: {}
  };

  return (
    <Index indexId={indexId} root={indexObject}>
      <IfHits condition={searchCondition}>
        <RefinedResults
          label={label}
          type={type}
          displayType={setDisplayState}
          currentDisplay={displayState}
        />
      </IfHits>
    </Index>
  );
}

export default function SearchPanelRefinedResults({
  displayState,
  setDisplayState,
  searchCondition,
  redirectLinks,
  searchOptions
}: SearchPanelRefinedResultsProps) {
  const items = searchTypes({ redirectLinks, searchOptions });

  return (
    <>
      {items.map((item: any = {}) => {
        const { indexId, label, type } = item;

        return (
          <RefinedResultsItem
            key={type}
            indexId={indexId}
            label={label}
            type={type}
            displayState={displayState}
            setDisplayState={setDisplayState}
            searchCondition={searchCondition}
          />
        );
      })}
    </>
  );
}
